import * as AccountService from 'services/accounts'
import * as AccountsTable from 'components/Admin/Accounts/AccountsTable'
import * as AccountsTableColumns from 'components/Admin/Accounts/AccountsTableColumns'

import {
  Container,
  Header
} from 'semantic-ui-react'
import React, { useEffect, useState } from 'react'

export default function ParterAccounts(props) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  const partnerName = props?.match?.params?.partnername ?? undefined;

  const refreshAccounts = (partner) =>
    AccountService.fetchPartnerAccounts(partner).then(data =>
      setAccounts(data.accounts)
    )

  // Initial load
  useEffect(() => {
    if(!!partnerName){
      refreshAccounts(partnerName).finally(() => setLoading(false));
    }else{
      console.log("Partner name not specified");
      setLoading(false);
    }
  }, [partnerName])

  return (
    <Container fluid style={{ padding: '2em' }}>
      <Header as='h1'>{partnerName ? partnerName.toUpperCase() : ""}</Header>
      <AccountsTable.AccountsTable
        accounts={accounts}
        columns={[
          AccountsTableColumns.EmailAddress,
        ]}
        loading={loading}
        selectedAccount={null}
        onSelectAccount={() => {}}
      >
      </AccountsTable.AccountsTable>
    </Container>
  )
}
